import React from 'react';
import { FormGroup, ControlLabel, Col } from 'react-bootstrap';
import './styles.scss';

const ComCheckbox = ({
  value,
  label,
  labelSize,
  smFieldSize,
  infoButton,
  inline,
  width,
  communicationType,
  onCommunicationChange,
}) => {
  const handleChange = (e) => {
    const newValue = e.target.checked;
    onCommunicationChange(communicationType, newValue);
  };
  return (
    <FormGroup>
      {label && (
        <Col sm={labelSize ? labelSize : 2}>
          <ControlLabel className={+inline ? ' inline-radio-label' : ''}>
            {label}
          </ControlLabel>{' '}
          {infoButton}
        </Col>
      )}

      <Col
        sm={smFieldSize ? smFieldSize : 12 - (labelSize ? labelSize : 2)}
        className={'radio-group'}
      >
        <div
          className={'radio-container' + (inline ? ' inline' : '')}
          style={width ? { width: width } : {}}
        >
          <div className={'comms-checkbox'}>
            <input
              type="checkbox"
              id={`com-checkbox-${communicationType}`}
              value={value}
              checked={value}
              onChange={handleChange}
            />
            <label htmlFor={`com-checkbox-${communicationType}`} />
          </div>
          <div className="radio-label" />
        </div>
      </Col>
    </FormGroup>
  );
};

export default ComCheckbox;
